import { DeepPartial } from "../interfaces/deepPartial";
import { ModelState } from "../interfaces/modelState";
import { get, post } from "../lib/fetchUtil";
import {
  CalculatePremiumResponse,
  CalculationModel,
  SaveDlpStateRequest,
} from "../providers/dlpFlow/DlpFlow.interfaces";
import { MortgageSupplier } from "./dlp.interfaces";

export async function calculatePremium(
  calculationModel: DeepPartial<CalculationModel>
): Promise<CalculatePremiumResponse> {
  const response = await post("dlpflow/calculate", calculationModel);
  return response.json();
}

export async function fetchMortgageList(): Promise<MortgageSupplier[]> {
  const response = await get("dlpflow/mortgagelist");

  return response.json();
}

export async function updateDlpState(data: SaveDlpStateRequest): Promise<{ applicationId?: string }> {
  const response = await post(`dlpflow/saveDlpState`, data);
  return response.json();
}

export async function submitDlpState(url: string, data: object) {
  const response = await post(url, data);
  const result = (await response.json()) as { modelState: ModelState } | undefined;
  if (response.status === 200 || response.status === 400) {
    return result;
  } else {
    throw Error("FAILED_FETCH_SUBMIT_DLP_STATE");
  }
}
